/**
 * @file Filter
 */

import { gsap } from 'gsap';

/**
 * Filter component
 */
const vFilter = () => {
	const filter = document.querySelector( '.v-filter' );
	const grid   = document.querySelector( '.v-card-list' );
	if ( ! filter || ! grid ) {
		return;
	}

	const featuredPost = document.querySelector( '.v-featured-wrap' );

	document.addEventListener( 'facetwp-refresh', () => {
		if ( FWP.paged > 1 ) {
			featuredPost.classList.add( 'v-featured-wrap--hide' );
		} else {
			featuredPost.classList.remove( 'v-featured-wrap--hide' );
		}
		gsap.to( grid, { opacity: .2 } );
	} );

	document.addEventListener( 'facetwp-loaded', () => {
		gsap.to( grid, { opacity: 1 } );
	} );
};

export default vFilter;
